import { OrgLevelTypeEnum } from "../enums/orgLevelType.enum";

export class AgentOrgLevel {
    agentId: string;
    organizationLevelId: string;
    healthAdvisory: string;
    specificRecommendations: string;
    agentName: string;
    organizationLevelName: string;
    OrgLevelType?: OrgLevelTypeEnum;
}
